import initAddToCart from './add-to-cart'
import initRemoveFromCart from './remove-from-cart'

require('./update-cart')

class Cart {
  constructor() {
    this.cart = document.querySelector('.c-cart')
    if (!this.cart) return

    this.body = document.body
    this.toggles = document.querySelectorAll('.js-toggle-cart')
    this.close = document.querySelector('.js-cart-close')
    this.itemsCount = document.querySelector('.js-cart-items')
    this.subTotal = document.querySelector('.js-cart-subtotal')
    this.itemsList = document.querySelector('.c-cart__items')
    this.bg = document.querySelector('.c-cart__bg')

    this.state = false
    this.init()
  }

  init() {
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        this.toggleCart()
      })
    })

    this.close.addEventListener('click', () => {
      this.closeCart()
    })

    this.bg.addEventListener('click', () => {
      this.closeCart()
    })

    initAddToCart()
    initRemoveFromCart()

    window.emitter.on('update-cart', (payload) => {
      // console.log('on update-cart -  from cart.js')
      if (payload.error === true) {
        throw new Error('AJAX - Update Cart error')
      }

      if (payload.itemsCount <= 0) {
        this.updateCart(payload)
        this.closeCart()
        return
      }
      this.updateCart(payload)
      if (!this.state) this.openCart()
    })
  }

  updateCart({ subTotal, itemsCount, items }) {
    this.itemsCount.innerHTML = itemsCount
    this.subTotal.innerHTML = `${subTotal}`

    let itemsHTML = ''
    // console.log(items)
    items.forEach((item) => {
      itemsHTML += `
      <li class="c-cart__item">
        <div class="c-cart__thumbnail">
              <a class="c-cart__link" href="${item.permalink}">${item.thumbnail}</a>
        </div>
        <div class="c-cart__details">
            <div class="c-cart__title">
                <a class="c-cart__link" href="${item.permalink}">
                ${item.title} <span class="c-cart__count">(${item.quantity})</span>
                </a>
            </div>
            <div class="c-cart__quantity">
            <input type="number" min="1" max="999" value="${item.quantity}">
            X ${item.price}€
            </div>
            <button class="c-cart__remove c-button js-remove-from-cart" aria-label="Remove element" data-variation-id="${item.variation_id}" data-product-id="${item.product_id}" data-product-sku="${item.product_sku}">
                Supprimer
            </button>
        </div>
    </li>`
    })
    this.itemsList.innerHTML = itemsHTML

    // console.log('before cart-updated -  from cart.js')
    window.emitter.emit('cart-updated')
  }

  toggleCart() {
    if (this.state) {
      this.closeCart()
    } else {
      this.openCart()
    }
  }

  closeCart() {
    document.body.classList.remove('is-locked-mobile')
    document.body.classList.remove('has-cart')
    this.cart.classList.remove('c-cart--active')
    this.bg.classList.remove('c-cart__bg--active')
    this.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', false)
    })
    this.state = false
  }

  openCart() {
    this.cart.style.opacity = 1
    document.body.classList.add('is-locked-mobile')
    document.body.classList.add('has-cart')
    this.cart.classList.add('c-cart--active')
    this.bg.classList.add('c-cart__bg--active')
    this.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', true)
    })
    this.state = true
  }
}

export default Cart
